import { TYPES } from "./finance_manager.type";
import { getDocs, query, where } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const app = getApp();
const auth = getAuth(app);

// ========= firebase function =========//

//snap all provider
export const getFinanceManagerByDate =
  ({ from, to }, callback) =>
  (dispatch) => {
    const start = from?.startOf("days")?.toDate();
    const end = to?.endOf("days")?.toDate();
    console.log({ start, end });
    const uid = auth?.currentUser?.uid;
    setFinanceManagerAllSuccess(dispatch, null);
    const cRef = getRefs().manager;
    const c0 = where("owner", "==", uid);
    const c1 = where("database", "==", "draft");
    const c2 = where("collection", "==", "dialog");
    const c3 = where("source", "==", "manager");
    const c4 = where("setAt", ">=", start);
    const c5 = where("setAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2, c3, c4, c5);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        console.log("snap dates:" + JSON.stringify(data));
        setFinanceManagerAllSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
  };

// ========= cloud function =========//
// ========= local function =========//
export const setFinanceManagerAll = (data, callback) => (dispatch) => {
  setFinanceManagerAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceManagerOpenAdd = (data, callback) => (dispatch) => {
  setFinanceManagerOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceManagerOpenEdit = (data, callback) => (dispatch) => {
  setFinanceManagerOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceManagerSelected = (data, callback) => (dispatch) => {
  setFinanceManagerSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceManagerSearch = (data, callback) => (dispatch) => {
  setFinanceManagerSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};
export const setFinanceManagerDates = (data, callback) => (dispatch) => {
  setFinanceManagerDatesSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setFinanceManagerAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_MANAGER_ALL,
    payload: data,
  });
};

const setFinanceManagerOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_MANAGER_OPEN_ADD,
    payload: data,
  });
};

const setFinanceManagerOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_MANAGER_OPEN_EDIT,
    payload: data,
  });
};

const setFinanceManagerSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_MANAGER_SELECTED,
    payload: data,
  });
};

const setFinanceManagerSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_MANAGER_SEARCH,
    payload: data,
  });
};

const setFinanceManagerDatesSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_MANAGER_DATES,
    payload: data,
  });
};
